// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../../utils/Utils.bs.js");
var React = require("react");
var Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
var Sentry = require("../../../reason/Sentry.bs.js");
var PageTitle = require("../../../reason/common/PageTitle.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var LoggedInAgent = require("../../../reason/common/UserSession/LoggedInAgent.bs.js");
var MarkupHelpers = require("../../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
var ErrorComponent = require("../../../reason/common/Error/ErrorComponent.bs.js");
var $$ResizeObserver = require("../../../reason/common/ResizeObserver.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var ReactErrorBoundary = require("react-error-boundary");
var ConversationsListRelay = require("./ConversationsListRelay.bs.js");
var ConversationsEmptyState = require("./ConversationsEmptyState.bs.js");
var ConversationsPageRelayCommon = require("./ConversationsPageRelayCommon.bs.js");
var ConversationPageNewConversation = require("./ConversationPageNewConversation.bs.js");
var ConversationsPageRelayQuery_graphql = require("../../../__generated__/ConversationsPageRelayQuery_graphql.bs.js");
var ConversationPageExistingConversation = require("./ConversationPageExistingConversation.bs.js");

function useDecodeSelectedConversation(slug) {
  var match = ConversationsPageRelayCommon.QueryParams.use();
  var queryParams = match[0];
  return React.useMemo((function () {
                if (slug === undefined) {
                  return {
                          TAG: "Ok",
                          _0: undefined
                        };
                }
                if (slug !== "new") {
                  return {
                          TAG: "Ok",
                          _0: {
                            TAG: "Existing",
                            _0: slug
                          }
                        };
                }
                var id = queryParams.context_id;
                if (id !== undefined) {
                  var contextType = queryParams.context_type;
                  if (contextType !== undefined) {
                    return {
                            TAG: "Ok",
                            _0: {
                              TAG: "New",
                              _0: contextType,
                              _1: id
                            }
                          };
                  }
                  
                }
                return {
                        TAG: "Error",
                        _0: {
                          message: "Could not decode the required query params got (" + Core__Option.getOr(id, "") + ", " + Core__Option.getOr(Core__Option.map(queryParams.context_type, ConversationsPageRelayCommon.EntityType.toString), "") + ") for new conversation"
                        }
                      };
              }), [
              slug,
              queryParams
            ]);
}

var SelectedConversation = {
  useDecodeSelectedConversation: useDecodeSelectedConversation
};

var convertVariables = ConversationsPageRelayQuery_graphql.Internal.convertVariables;

var convertResponse = ConversationsPageRelayQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = ConversationsPageRelayQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, ConversationsPageRelayQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, ConversationsPageRelayQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(ConversationsPageRelayQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(ConversationsPageRelayQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(ConversationsPageRelayQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(ConversationsPageRelayQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function ConversationsPageRelay$Page(props) {
  var query = use(undefined, undefined, undefined, undefined);
  var selectedConversationId = useDecodeSelectedConversation(props.slug);
  var selectedId;
  if (selectedConversationId.TAG === "Ok") {
    var match = selectedConversationId._0;
    selectedId = match !== undefined && match.TAG === "Existing" ? match._0 : undefined;
  } else {
    selectedId = undefined;
  }
  var isNewConversation;
  if (selectedConversationId.TAG === "Ok") {
    var match$1 = selectedConversationId._0;
    isNewConversation = match$1 !== undefined && match$1.TAG !== "Existing" ? true : false;
  } else {
    isNewConversation = false;
  }
  var hasSelectedConversation = Core__Option.isSome(selectedId);
  var mainElementRef = React.useRef(undefined);
  var match$2 = $$ResizeObserver.useElementSize(mainElementRef);
  var mainHeight = match$2[0];
  var hasConversations = query.conversationsCount.totalCount > 0 || isNewConversation;
  var tmp;
  if (hasConversations) {
    var tmp$1;
    if (selectedConversationId.TAG === "Ok") {
      var originalConversationId = selectedConversationId._0;
      tmp$1 = originalConversationId !== undefined ? (
          originalConversationId.TAG === "Existing" ? JsxRuntime.jsx(React.Suspense, {
                  children: Caml_option.some(JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(ConversationPageExistingConversation.make, {
                                  selectedConversationId: originalConversationId._0
                                }),
                            className: "bg-white rounded-md"
                          })),
                  fallback: Caml_option.some(JsxRuntime.jsx(Loader.make, {}))
                }) : JsxRuntime.jsx(React.Suspense, {
                  children: Caml_option.some(JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(ConversationPageNewConversation.make, {
                                  entityType: originalConversationId._0,
                                  entityId: originalConversationId._1,
                                  originalConversationId: originalConversationId
                                }),
                            className: "bg-white"
                          })),
                  fallback: Caml_option.some(JsxRuntime.jsx(Loader.make, {}))
                })
        ) : JsxRuntime.jsx(ConversationsPageRelayCommon.RecordPageView.ConversationsList.make, {});
    } else {
      tmp$1 = null;
    }
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(ConversationsListRelay.make, {
                                    query: query.fragmentRefs,
                                    selectedConversationId: selectedId,
                                    isNewConversation: isNewConversation
                                  }),
                              className: "rounded-md overflow-hidden min-h-[calc(100vh-250px)] lg:min-h-[calc(100vh-200px)] bg-white",
                              style: {
                                height: mainHeight !== 0 ? mainHeight.toString() + "px" : undefined
                              }
                            }),
                        className: TailwindMerge.twMerge([
                              isNewConversation || hasSelectedConversation ? "hidden lg:block" : "col-span-12",
                              "lg:col-span-4 border-r lg:border-r-0"
                            ])
                      }),
                  JsxRuntime.jsx("div", {
                        children: tmp$1,
                        ref: Caml_option.some(function (e) {
                              Utils.React.setCurrentRef(mainElementRef, (e == null) ? undefined : Caml_option.some(e));
                            }),
                        className: TailwindMerge.twMerge([
                              isNewConversation || hasSelectedConversation ? "col-span-12" : "hidden lg:block",
                              "lg:col-span-8 min-h-[200px] h-full bg-white lg:bg-transparent"
                            ])
                      })
                ],
                className: "grid grid-cols-12 lg:gap-6"
              }),
          className: TailwindMerge.twMerge(["w-full max-w-full -mt-6 lg:mt-0 lg:mx-auto lg:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1320px]"])
        });
  } else {
    tmp = JsxRuntime.jsx(ConversationsEmptyState.make, {});
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(PageTitle.make, {
                      title: "Conversations"
                    }),
                tmp
              ]
            });
}

var Page = {
  make: ConversationsPageRelay$Page
};

var defaultMessage = "There was a problem loading your conversations. Please refresh or try again later.";

function ConversationsPageRelay$ErrorState(props) {
  var __message = props.message;
  var message = __message !== undefined ? __message : defaultMessage;
  return JsxRuntime.jsx(MarkupHelpers.Container.make, {
              children: JsxRuntime.jsx(ErrorComponent.make, {
                    message: message
                  })
            });
}

var ErrorState = {
  defaultMessage: defaultMessage,
  make: ConversationsPageRelay$ErrorState
};

function ConversationsPageRelay(props) {
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
              FallbackComponent: (function (_error) {
                  return JsxRuntime.jsx(ConversationsPageRelay$ErrorState, {});
                }),
              children: JsxRuntime.jsx(LoggedInAgent.Provider.make, {
                    children: JsxRuntime.jsx(ConversationsPageRelay$Page, {
                          slug: Core__Option.flatMap(Caml_option.nullable_to_opt(props.slug), (function (__x) {
                                  return __x[0];
                                }))
                        })
                  }),
              onError: (function (error) {
                  Sentry.captureException(error, "ConversationsPageRelay.res", undefined, undefined, undefined);
                })
            });
}

var make = ConversationsPageRelay;

exports.SelectedConversation = SelectedConversation;
exports.Query = Query;
exports.Page = Page;
exports.ErrorState = ErrorState;
exports.make = make;
/* use Not a pure module */
